import React, { useEffect, useMemo, useState } from 'react'
import styles from 'components/Nav/nav.module.scss'
import clsx from 'clsx'
import { Container, Icon, Typography } from 'gu-ui-kit'
import config from 'components/Nav/config'
import { NavLink } from 'react-router-dom'
import Nav from 'components/Nav'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import findMatchedRoutes from 'utils/findMatchedRoutes'
import { useLocation } from 'react-router'
import { SET_DRAWER_STATE } from 'modules/App/types'
import { useDispatch } from 'react-redux'

const SubLevel = ({
  label_key,
  exact,
  path,
  icon,
  routes = [],
  level,
  routeKey = '',
  collapse,
}) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  const matchedRoutes = findMatchedRoutes(routes)
  const to = Array.isArray(path) ? path[0] : path
  const [open, setOpen] = useState(routes.length > 0 && matchedRoutes.length > 0)
  const location = useLocation()

  const LinkComponent = useMemo(() => {
    if (config?.[routeKey]) {
      return config?.[routeKey]
    }

    if (routes?.length > 0) {
      return 'div'
    }

    return NavLink
  }, [routes, routeKey])

  useEffect(() => {
    if (routes.length > 0) {
      setOpen(matchedRoutes.length > 0)
    }
  }, [location])

  return (
    <
      // className={styles['nav__item']}
    >
      <LinkComponent
        key={routeKey}
        title={t(label_key)}
        className={clsx(styles['nav__link'], 'nav__link_sublevel', {
          //eslint-disable-next-line
          [styles['nav__link_opener']]: routes?.length > 0,
          ['opened']: open,
          ['nav__link_opener']: routes?.length > 0,
          [styles['nav__link_collapsed']]: collapse,
          [styles['nav__link_active']]: routes?.length > 0 && !open && matchedRoutes.length > 0,
        })}
        onClick={() => {
          //eslint-disable-next-line
          if (routes?.length > 0) {
            dispatch({ type: SET_DRAWER_STATE, payload: { collapsed: false } })
            setOpen((open) => !open)
            return false
          }

          return true
        }}
        {...(LinkComponent !== 'div'
          ? { activeClassName: styles['nav__link_active'], exact, to: pathGen(to) }
          : {})}
      >
        {icon && (
          <span className={styles['nav__icon']}>{React.cloneElement(icon, { width: 20 })}</span>
        )}
        <Typography
          variant={'Body-15'}
          className={styles['nav__text']}
          noMargin
        >
          {t(label_key)}
        </Typography>

        {
          //eslint-disable-next-line
          routes?.length > 0 && (
            <span className={styles['nav__link_opener']}>
              <Icon
                className={clsx(styles['nav__link_opener-icon'], {
                  [styles['nav__link_opener-icon_open']]: open,
                })}
                width={20}
                name={'arrow-down'}
                size={'m'}
              />
            </span>
          )
        }
      </LinkComponent>
      {
        //eslint-disable-next-line
        routes?.length > 0 && (
          <Container
            display={'flex'}
            className={clsx(styles['collapse-wrapper'], {
              ['opened']: open,
            })}
            onFocus={() => {
              if (!open) {
                setOpen(true)
              }
            }}
          >
            <Nav
              collapse={collapse}
              items={routes}
              level={level + 1}
            />
          </Container>
        )
      }
    </>
  )
}

export default SubLevel

SubLevel.propTypes = {
  collapse: PropTypes.bool,
  icon: PropTypes.oneOfType([
    PropTypes.oneOf([null]),
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  exact: PropTypes.bool,
  routeKey: PropTypes.string,
  label_key: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object),
  level: PropTypes.number.isRequired,
  openedGroup: PropTypes.string,
  setOpenedGroup: PropTypes.func,
}
